import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './trade.css';
import './usage';
if ('serviceWorker' in navigator) addEventListener('load', () => { void navigator.serviceWorker.register('/sw.js').catch(() => undefined); });

createRoot(document.getElementById('root')!).render(<StrictMode><App /></StrictMode>);
